import ChartTab from "./ChartTab";
import React from "react";
import _ from "lodash-es";
import computeDefaultTableSize from "../../tools/computeDefaultTableSize";

const FIXED0 = value => {
  return Number.parseFloat(Number.parseFloat(value).toFixed(0));
};

class ChartBudgetClientClientTabPure extends React.Component {
  render() {
    const { data } = this.props;
    let pivots = ["tiersGroup", "tiers", "project"]; //"year", "amount", "budget"
    let showColumns = [
      "tiersGroup",
      "tiersAsClient",
      "project",
      "dateMonthYear",
      "previousYearRealValueOrBudget",
      "budget",
      "realValue",
      "budgetVariation",
      "budgetVariationPourcent"
    ];

    if (!!data) {
      for (let line of data) {
        line.dateMonthYear = line.year + "-" + ("0" + line.month).slice(-2);
        line.budgetVariation = FIXED0(line.realValue - line.amount);
        if (line.amount !== 0)
          line.budgetVariationPourcent = _.round(
            (line.budgetVariation / line.amount) * 100.0,
            2
          );
        else line.budgetVariationPourcent = 0.0;
      }

      // for (let line of data)
      //   console.log("Line=", line);
    }
    return (
      <ChartTab
        {...this.props}
        data={data}
        defaultPageSize={computeDefaultTableSize(data, "tiers")}  // tiersGroup ?
        pivots={pivots}
        showColumns={showColumns}
        showPagination={false}
        showDetails={false}
        showExtra={true}
        defaultSorted={[
          {
            id: "tiers",
            desc: false
          }
        ]}
      />
    );
  }
}

export default ChartBudgetClientClientTabPure;
